<div *ngIf="show" class="dialog-backdrop">
  <div class="dialog-container">
    <div class="dialog-content">
      <p>{{ message }}</p>
    </div>
    <div class="dialog-actions">
      <button class="btn btn-danger" (click)="onConfirm()">{{ confirmText }}</button>
      <button class="btn btn-secondary" (click)="onCancel()">{{ cancelText }}</button>
    </div>
  </div>
</div>
